import React from "react";
import { Button } from "semantic-ui-react";
import "./HeaderPage.scss";

export function HeaderPage(props) {
  const {
    title,
    btnTitle,
    btnClick,
    btnDisabled,
    btnTitleTwo,
    btnClickTwo,
    btnTitleTwoDisabled,
    btnTitleThree,
    btnClickThree,
    btnTitleThreeDisabled,
  } = props;

  return (
    <div className="header-page-admin">
      <h2>{title}</h2>

      <div>
        {btnTitle && (
          <Button positive disabled={btnDisabled} onClick={btnClick}>
            {btnTitle}
          </Button>
        )}
        {btnTitleTwo && (
          <Button negative disabled={btnTitleTwoDisabled} onClick={btnClickTwo}>
            {btnTitleTwo}
          </Button>
        )}
        {btnTitleThree && (
          <Button
            className="header-page-admin__btn-warning"
            disabled={btnTitleThreeDisabled}
            onClick={btnClickThree}
          >
            {btnTitleThree}
          </Button>
        )}
      </div>
    </div>
  );
}
